import {
    enrichissementMenu,
    navigationMenuMobile,
    openMenu,
    resetMenu
} from "./effets/menu";
import { stickyHeader } from "./effets/stickyHeader";
import { initializeTooltips } from "./effets/tooltips";

export const mobileBreakPoint = 991;

window.addEventListener("resize", () => {
    resetMenu();
});

document.addEventListener("DOMContentLoaded", () => {
    stickyHeader();
    initializeTooltips();
    resetMenu();
    enrichissementMenu();
    navigationMenuMobile();

    document
        .querySelector(".menuSite-bouton")
        .addEventListener("click", (event) => {
            openMenu(event.target, ".menuSite-bouton");
        });
});
